var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef, useState } from "react";
/**
 * Only for web! On mobile, use FlatList.onEndReached
 */
const useInView = ({ element, onReached }) => {
    const observer = useRef();
    const [isFetching, setFetching] = useState(false);
    useEffect(() => {
        if (observer.current) {
            observer.current.disconnect();
        }
        if (!element || !onReached) {
            return;
        }
        observer.current = new IntersectionObserver((entries) => {
            if (isFetching) {
                return;
            }
            if (!entries[0].isIntersecting) {
                return;
            }
            void (() => __awaiter(void 0, void 0, void 0, function* () {
                setFetching(true);
                try {
                    yield onReached(); // This await makes no sense TODO
                }
                finally {
                    setFetching(false);
                }
            }))();
        });
        observer.current.observe(element);
    }, [element, isFetching, onReached]);
    return isFetching;
};
export default useInView;
